import type { ReactNode, SVGProps } from "react";

export function ArrowsSortIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="1em"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			viewBox="0 0 8 20"
			width="0.4em"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g data-arrow="ascending">
				<path d="M7 4L4 1L1 4" />
				<path d="M4 1V7" />
			</g>
			<g data-arrow="descending">
				<path d="M1 16L4 19L7 16" />
				<path d="M4 13V19" />
			</g>
		</svg>
	);
}
